import type { EncounterStatus } from "../../shared/types/encounter";

// Nhãn theo "Danh sách yêu cầu" của SalePro (quyết định 02/11/2026): "Đang thực hiện" /
// "Hoàn thành" / "Đã hủy". Mã trạng thái không đổi — SIGNED vẫn là lần khám đã ký.
export const STATUS_LABEL: Record<EncounterStatus, string> = {
  IN_PROGRESS: "Đang thực hiện",
  SIGNED: "Hoàn thành",
  CANCELLED: "Đã hủy",
};

export const STATUS_TONE: Record<EncounterStatus, "info" | "success" | "danger"> = {
  IN_PROGRESS: "info",
  SIGNED: "success",
  CANCELLED: "danger",
};
